module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/instagram/chapel_sns_02-00eb7c137a55861929dafe979a9b5d82.jpg";